import { TitlePdfPrintQueue } from "../model";
import { BaseAPI } from "./internal";

class TitlePdfPrintQueueAPI extends BaseAPI<TitlePdfPrintQueue> {
  constructor() {
    super("");
  }

  public AddToPrintQueue: (ruleId: number) => Promise<any> = async (
    ruleId: number
  ) => {
    const response = await BaseAPI.axios.put(
      `${this.apiUrl}/request-rule-documents/${ruleId}`
    );
    return response.data;
  };
}
export const titlePdfPrintQueueAPI = new TitlePdfPrintQueueAPI();
